module.exports = __webpack_public_path__ + "img/tick.caf60554.svg";